import * as React from 'react'
import FormControlLabel, {
  FormControlLabelProps,
} from '@mui/material/FormControlLabel'
import styled from 'styled-components'
import CheckboxLabelStyles from './checkbox_w_label.styles'

type CheckboxLabelProps = FormControlLabelProps
const apAtomName = {ap_atom_name: 'checkboxLabelAtom'}

const CheckboxLabelAtom = styled((props: CheckboxLabelProps) => (
  <FormControlLabel {...apAtomName} {...props} />
))`
  ${CheckboxLabelStyles}
`

export default CheckboxLabelAtom
